import { produce } from "immer";
import {
  PRINT_REVIEW,
  PRINT_REVIEW_FAILURE,
  PRINT_REVIEW_SUCCESS,
  PRINT_SCORE,
  PRINT_SCORE_FAILURE,
  PRINT_SCORE_SUCCESS,
  PRINT_BADGE,
  PRINT_BADGE_SUCCESS,
  PRINT_BADGE_FAILURE,
} from "./constants";

export const initialState = {
  isPritingScore: false,
  isPritingReview: false,
  isPritingBadge: false,
};

const PrintReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case PRINT_SCORE:
        draft.isPritingScore = true;
        break;
      case PRINT_SCORE_SUCCESS:
        draft.isPritingScore = false;
        break;
      case PRINT_SCORE_FAILURE:
        draft.isPritingScore = false;
        break;

      case PRINT_REVIEW:
        draft.isPritingReview = true;
        break;
      case PRINT_REVIEW_SUCCESS:
        draft.isPritingReview = false;
        break;
      case PRINT_REVIEW_FAILURE:
        draft.isPritingReview = false;
        break;

      case PRINT_BADGE:
        draft.isPritingBadge = true;
        break;
      case PRINT_BADGE_SUCCESS:
        draft.isPritingBadge = false;
        break;
      case PRINT_BADGE_FAILURE:
        draft.isPritingBadge = false;
        break;

      default:
        return state;
    }
  });

export default PrintReducer;
